import { z } from "zod";

/** Stable public IDs are UUIDv7 (time-ordered, safe to expose). */
export const id = z.uuid({ version: "v7" });

export const email = z.email().trim().toLowerCase().max(254);

export const slug = z
  .string()
  .trim()
  .toLowerCase()
  .min(3)
  .max(48)
  .regex(/^[a-z0-9]+(?:-[a-z0-9]+)*$/, "Use lowercase letters, numbers and single hyphens");

/** Cursor pagination input shared by every list endpoint (API conventions). */
export const pageInput = z.object({
  cursor: z.string().max(512).nullish(),
  limit: z.number().int().min(1).max(100).default(20),
});
export type PageInput = z.infer<typeof pageInput>;

export interface Page<T> {
  items: T[];
  nextCursor: string | null;
}

/** Optimistic concurrency: callers send the version they last saw. */
export const expectedVersion = z.number().int().min(1);
